// radius
export function getBoundsRadius(northEast, centerLatLng) {
  // r = radius of the earth in km
  let r = 6378.8;
  // degrees to radians (divide by 57.2958)
  let ne_lat = northEast.lat() / 57.2958;
  let ne_lng = northEast.lng() / 57.2958;
  let c_lat = centerLatLng.lat() / 57.2958;
  let c_lng = centerLatLng.lng() / 57.2958;
  // distance = circle radius from centerLatLng to Northeast corner of bounds
  let r_km =
    r *
    Math.acos(
      Math.sin(c_lat) * Math.sin(ne_lat) +
        Math.cos(c_lat) * Math.cos(ne_lat) * Math.cos(ne_lng - c_lng)
    );
  return r_km + 0.2; // radius in meters
}

// current lat, lng, merchant lat, lng
export function distance(lat1, lon1, lat2, lon2, unit) {
  if (lat1 === lat2 && lon1 === lon2) {
    return 0;
  } else {
    var radlat1 = (Math.PI * lat1) / 180;
    var radlat2 = (Math.PI * lat2) / 180;
    var theta = lon1 - lon2;
    var radtheta = (Math.PI * theta) / 180;
    var dist =
      Math.sin(radlat1) * Math.sin(radlat2) +
      Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    if (dist > 1) {
      dist = 1;
    }
    dist = Math.acos(dist);
    dist = (dist * 180) / Math.PI;
    dist = dist * 60 * 1.1515;
    if (unit === "K") {
      dist = dist * 1.609344;
    }
    if (unit === "N") {
      dist = dist * 0.8684;
    }
    return dist;
  }
}

export function appropriateDistance(d) {
  return d < 1 ? `${(d * 1000).toFixed(2)} m away` : `${d.toFixed(2)} km away`;
}
